<script setup lang="ts">
import type { PropType } from "vue";
import type { CollectionType } from "~/types";
import moment from "moment";

const props = defineProps({
  airDate: {
    type: Date,
    required: true,
  },
  videoType: {
    type: String as PropType<CollectionType>,
    required: true,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  fluid: {
    type: Boolean,
    required: false,
  },
});

const timer = ref({ days: 0, hours: 0, mins: 0, secs: 0 });
const countdown = ref<ReturnType<typeof setInterval>>();

onMounted(() => {
  countdown.value = setInterval(() => {
    calcTimeDifference();
  }, 1000);
});

function calcTimeDifference() {
  const duration = moment.duration(moment(props.airDate).diff(moment()));
  const day = Math.floor(
    moment.duration(moment(props.airDate).diff(moment())).asDays(),
  );
  timer.value = {
    days: day,
    hours: duration.hours(),
    mins: duration.minutes(),
    secs: duration.seconds(),
  };

  if (duration.asMilliseconds() < 500) {
    clearInterval(countdown.value);
    window.location.reload();
  }
}

const notation = computed(() => {
  if (props.videoType === "vod") return "AVAILABLE IN";
  if (props.videoType === "live") return "EVENT STARTS IN";
  return "";
});

const timerValues = computed(() => {
  return {
    days: String(timer.value.days).padStart(2, "0"),
    hours: String(timer.value.hours).padStart(2, "0"),
    mins: String(timer.value.mins).padStart(2, "0"),
    secs: String(timer.value.secs).padStart(2, "0"),
  };
});
</script>

<template>
  <div
    class="absolute bottom-0 flex h-full w-full flex-col items-center justify-center bg-black/70 backdrop-blur-sm"
  >
    <div v-if="showHeader" class="mb-2 text-center italic">
      {{ notation }}
    </div>
    <div
      :class="['flex justify-center gap-4 text-center', { 'w-full': fluid }]"
    >
      <div v-if="timerValues.days !== '00'" class="w-1/3">
        <div
          class="mb-2 rounded-md border border-surface-border bg-surface-bg p-5 text-3xl"
        >
          {{ timerValues.days }}
        </div>
        <div class="text-sm text-surface-400">DAYS</div>
      </div>
      <div class="w-1/3">
        <div
          class="mb-2 rounded-md border border-surface-border bg-surface-bg p-5 text-3xl"
        >
          {{ timerValues.hours }}
        </div>
        <div class="text-sm text-surface-400">HRS</div>
      </div>
      <div class="w-1/3">
        <div
          class="mb-2 rounded-md border border-surface-border bg-surface-bg p-5 text-3xl"
        >
          {{ timerValues.mins }}
        </div>
        <div class="text-sm text-surface-400">MINS</div>
      </div>
      <div v-if="timerValues.days === '00'" class="w-1/3">
        <div
          class="mb-2 rounded-md border border-surface-border bg-surface-bg p-5 text-3xl"
        >
          {{ timerValues.secs }}
        </div>
        <div class="text-sm text-surface-400">SECS</div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
